import FireSvgIcon from './fireSvgIcon';

export default function FireCount({count}) {
  return (
    <span className="userpostpage__firecount">
      <FireSvgIcon />
      {count}
    </span>
  );
}
